import { Injectable } from "@angular/core";
import { HttpService } from "./utils/http.service";
import { IOrendaChemicalHistoryModel, IStructureTypeModel, IStructureModel } from "@models";

@Injectable({ providedIn: 'root' })  //This automatically registers it globally

export class StructureTypeService {
    constructor(private readonly httpService: HttpService) { }

    getStructureTypes(): Promise<IStructureTypeModel[]> {
        return this.httpService.get("/structuretype/GetStructureTypes");
    }

    getStructures(customerId: number): Promise<IStructureModel[]> {
        return this.httpService.get("/structuretype/GetStructures", {customerId});
    }

    addStructure(structure: IStructureModel): Promise<number> {
        return this.httpService.post("/structuretype/AddStructure", structure);
    }

    updateStructure(structure: IStructureModel): Promise<number> {
        return this.httpService.post("/structuretype/UpdateStructure", structure);
    }

    deleteStructure(structure: IStructureModel): Promise<void> {
        return this.httpService.post("/structuretype/DeleteStructure", structure.id);
    }
}